"use client";

import { GenericFormPage, type GenericFormConfig } from "@admin/_components/generic-form-page";

const config: GenericFormConfig = {
  title: "Webinar",
  addTitle: "Add Webinar",
  editTitle: "Edit Webinar",
  fetchEndpoint: "webinar/webinar-single-fetch",
  addEndpoint: "webinar/webinar-add",
  editEndpoint: "webinar/webinar-update",
  backPath: "/admin/webinars",
  fields: [
    { key: "title", label: "Title", type: "text", required: true },
    { key: "priority", label: "Priority", type: "number", required: true },
    {
      key: "frequency",
      label: "Frequency",
      type: "select",
      // W-04: frequency is required in Angular
      required: true,
      options: [
        { value: "daily", label: "Daily" },
        { value: "weekly", label: "Weekly" },
        { value: "monthly", label: "Monthly" },
        { value: "customs", label: "Custom" },
      ],
    },
    // W-04: description is required in Angular
    { key: "description", label: "Description", type: "textarea", required: true, colSpan: 2 },
    { key: "status", label: "Active", type: "switch" },
  ],
};

export default function WebinarFormPage() {
  return <GenericFormPage config={config} />;
}
